import React from "react";
import Modal from "../../../components/modal";

const NoteViewModal = ({ show, onClose, heading, initialData = {} }) => {
    let notes = [];

    try {
        notes = JSON.parse(initialData?.notes || "[]");
    } catch (error) {
        console.error("Invalid JSON in notes:", error);
        notes = [];
    }

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            {Array.isArray(notes) && notes.length > 0 ? (
                notes.map((note, index) => (
                    <div key={index} className="row p-3">
                        <p>{index + 1}. <strong>Note:</strong> {note.note}</p>
                    </div>
                ))
            ) : (
                <p>No customer details available</p>
            )}
        </Modal>
    );
};

export default NoteViewModal;
